import React, { useContext, useEffect, useState } from 'react'
import { BranchDetailsTab, ButtonHeading } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';

import useDocumentTitle from 'hooks/useDocumentTitle';
import { useLocation, useNavigate } from 'react-router-dom';
import BranchSetting from './BranchSetting';
import BranchLrFormat from './BranchLrFormat';
import EwayBillIntegration from './EwayBillIntegration';
import { UserContext } from 'context';

const BranchDetails = () => {
    useDocumentTitle("Branch Details | T360");

    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tabFromQuery = parseInt(queryParams.get('tab')) || 1;
    const [activeTab, setActiveTab] = useState(tabFromQuery);
    // const [activeTab, setActiveTab] = useState(1);
    const [branchData, setBranchData] = useState(null)
    const [visibleTabs, setVisibleTabs] = useState([])

    const [branchDetailsTabs, setBranchDetailsTabs] = useState(constant.branchDetailsTabs);

    const { setMasterDetailsList} = useContext(UserContext);

    const getBranchTabs = (baseTabs, perms) => {
        return baseTabs.map((tab) => {
            const perm = perms.find((el) => el?.name === tab.title);
            if (!perm) return tab;

            const statusKey = [
                "available",
                "not_available",
                "premium",
                "coming_soon",
                "full_access",
            ].find((k) => perm[k] === 1);

            return {
                ...tab,
                ...(statusKey ? { key: statusKey } : {}),
                disabled: perm.web !== 1,
            };
        });
    };

    const onDataFetch = (data) => {
        setBranchData(data);
        const { company_id } = data;
        const { subscription_data } = company_id;

        const companyPermission = subscription_data?.company_settings;
        const tabPermission = companyPermission?.find((i) => i?.sort === 2);
        const consignorTabs = tabPermission.permissions ?? [];

        setBranchDetailsTabs(getBranchTabs(constant.branchDetailsTabs, consignorTabs));
        // Create a Set of enabled tabs where web === 1
        const enabledTabs = new Set(
            tabPermission?.permissions
                ?.filter((item) => item.web === 1)
                ?.map((item) => item.name)
        );

        // Filter branchDetailsTabs → always show Branch Details & LR Format
        const filteredTabs = constant.branchDetailsTabs.filter((tab) => {
            if (tab.title === "Branch Details" || tab.title === "LR Format") {
                return true;
            }
            // For Settings & Eway Bill Integration → show only if web === 1
            return enabledTabs.has(tab.title);
        });

        setVisibleTabs(filteredTabs);
    };

    const handleActiveTabs = (e) => {
        setActiveTab(e);

        const params = new URLSearchParams(location.search);
        params.set('tab', e);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const tabProps = {
        tabList: branchDetailsTabs,
        callBackTab: (e) => handleActiveTabs(e),
        activeTab: activeTab,
        keyStatusInsideTabs: true,
    }

    return (
        <>
            <ButtonHeading
                title={branchData?.branch}
                buttonTitle="Back"
                isBackButton={true}
                onClickBackButton={() => { navigate('/account/branch'); setMasterDetailsList({}) }} // navigate(-1)
            />

            <div className='__branch_deMain'>
                <div className='addPr_flBx commonDetails_bxs'>
                    <Tab {...tabProps} />
                    {activeTab === 1 && (
                        <BranchDetailsTab onDataFetch={onDataFetch} />
                    )}
                    {activeTab === 2 && (
                        // <BranchOtherDetailsTab onDataFetch={onDataFetch} />
                        <BranchSetting onDataFetch={onDataFetch} />
                    )}

                    {activeTab === 3 && (
                        <BranchLrFormat onDataFetch={onDataFetch} />
                    )}

                    {activeTab === 4 && (
                        // <BranchOtherDetailsTab onDataFetch={onDataFetch} />
                        <EwayBillIntegration onDataFetch={onDataFetch} />
                    )}
                </div>
            </div>
        </>
    )
}

export default BranchDetails;